import { useEffect, useRef, useState } from "react";
import ProductCard from "./ProductCard";
import { mapProductToCard } from "../../../utils/mapProduct";
import { getProducts } from "../../../api/apiServices";

export default function BestSellerSection() {
  const scrollRef = useRef(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const fetchBestSellers = async () => {
      try {
        const data = await getProducts();

        // filter badge
        const best = data.filter((p) => {
          const badge = p.badge?.toLowerCase();
          return badge === "best seller" || badge === "hot";
        });

        setProducts(best.map(mapProductToCard));
      } catch (err) {
        console.error("Failed to load best sellers:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBestSellers();
  }, []);

  if (loading) return null;
  if (products.length === 0) return null;

  return (
    <section className="py-12">
      <div className="flex items-end justify-between mb-8">
        <div>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-gray-800 mb-2">
            Best Sellers
          </h2>
          <p className="text-gray-500 font-['Poppins'] text-sm">
            Our most loved pieces
          </p>
        </div>

        <div className="hidden md:flex gap-2">
          <button
            onClick={() => scroll("left")}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-200 hover:border-lilac-400 hover:text-lilac-400"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>

          <button
            onClick={() => scroll("right")}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-200 hover:border-lilac-400 hover:text-lilac-400"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>
      </div>

      <div className="relative w-full">
        <div
          ref={scrollRef}
          className="flex overflow-x-auto scrollbar-hide gap-4 pb-4 snap-x snap-mandatory"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          {products.map((product) => (
            <div key={product.id} className="w-[280px] flex-shrink-0 snap-start">
              <ProductCard {...product} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
